import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/core/auth/AuthContext'
import { AdminLayout } from '@/features/admin/AdminLayout'
import { ExpertLayout } from '@/features/expert/ExpertLayout'
import { ClientLayout } from '@/features/client/ClientLayout'
import { BureauLayout } from '@/features/bureau/BureauLayout'
import { BanqueLayout } from '@/features/banque/BanqueLayout'

export const RoleBasedRouter: React.FC = () => {
  const { user, isAdmin, isExpert, isClient, isBureau, isBanque } = useAuth()

  if (!user) {
    return <Navigate to="/signin" replace />
  }

  // Admin Routes
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="*" element={<Navigate to="/admin/whats-new" replace />} />
      </Routes>
    )
  }

  // Expert Routes
  if (isExpert) {
    return (
      <Routes>
        <Route path="/expert/*" element={<ExpertLayout />} />
        <Route path="*" element={<Navigate to="/expert/a-traiter" replace />} />
      </Routes>
    )
  }

  // Client Routes
  if (isClient) {
    return (
      <Routes>
        <Route path="/client/*" element={<ClientLayout />} />
        <Route path="*" element={<Navigate to="/client/reports" replace />} />
      </Routes>
    )
  }

  // Bureau Routes
  if (isBureau) {
    return (
      <Routes>
        <Route path="/bureau/*" element={<BureauLayout />} />
        <Route path="*" element={<Navigate to="/bureau/whats-new" replace />} />
      </Routes>
    )
  }

  // Banque Routes
  if (isBanque) {
    return (
      <Routes>
        <Route path="/banque/*" element={<BanqueLayout />} />
        <Route path="*" element={<Navigate to="/banque/dashboard" replace />} />
      </Routes>
    )
  }

  // Default fallback
  return <Navigate to="/signin" replace />
}